import {InputAdornment, Divider, ToggleButton, Switch, Autocomplete, Button, Checkbox, Select, MenuItem, OutlinedInput, Grid, Dialog, DialogTitle, DialogContent, InputLabel, FormControl, FormControlLabel,NativeSelect, Stack, TextField, DialogActions, Tooltip, Paper, Box, Typography, IconButton} from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import {format} from 'date-fns'
import React from "react";
import CalcItem from "./CTRL_CalcItem";
import MoreTimeIcon from "@mui/icons-material/MoreTime";

class HireExtend extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen:false,
            note:"",
            stop_job:null,
            originalDate:null,
            weeksAdded:0
        }
    }

    componentDidMount() {
        this.setState({note:this.props.row.notes_job})
        this.setState({stop_job:this.props.row.stop_job})
        this.setState({originalDate:this.props.row.stop_job})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.stop_job != this.state.originalDate && prevState.stop_job != this.state.stop_job) {
            this.setState({weeksAdded: Math.round((new Date(this.state.stop_job) - new Date(this.state.originalDate)) / 604800000)})
        }
    }

    render() {
        const handleDialogOpen = () => {
            this.setState({dialogOpen: true});
        };

        const checkOutdated = () => {
            const today = new Date();
              var dateString = this.state.stop_job;
              var date = new Date(dateString);

              if (today > date) {
                return <Typography pt={.8} style={{fontWeight: "bold",color: 'orange'}}>{dateString}</Typography>;
              } else if (today < date) {
                return  <Typography pt={.8}>{dateString}</Typography>;
              } else {
                return <Typography pt={.8} style={{fontWeight: "bold",color: 'aqua'}}>{dateString}</Typography>;
              }
        }

        const JobChange = (event) =>{
            event.preventDefault()

            console.log(event.nativeEvent.submitter.name)

            if (event.nativeEvent.submitter.name != 'submit'){

                handleDialogClose()
                return
            }

            var assets = {
                'id_job':this.props.row.id_job,
                'hashcode_job':this.props.row.hashcode_job,
                'update_column':'job',
                'update':{
                'weeks_count':this.state.weeksAdded,
                'stop_job':event.target.stop_job.value,
                'notes_job':event.target.notes_job.value
                }
            }
            console.log(assets)
            var url = '/api/job/extend_confirmation/'+this.props.row.hashcode+'/'+event.target.extend_by.value;


            fetch('/api/job/extend_confirmation', {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                    },
                    body: JSON.stringify(assets),
                }).then(res => res.json()).then(data => {
                    console.log("extension sent")
                    this.props.fn_update()
                    handleDialogClose()
                });
        }
        function keyPress(e){
            if(e.keyCode == 13){
                console.log('value', e.target.value);
                var url = '/api/job/extend_confirmation/'+this.props.hashcode+'/'+e.target.value;
                fetch(url).then(response => response.json()).then(data =>
                    handleDialogClose());
                }
        }
        const handleDialogClose = (event, reason) => {
            if (reason !='backdropClick'){this.setState({dialogOpen: false})

            console.log('closed')
            }
        };

        const handleTextChange = (event, key) => {
            this.setState({[key]:event.target.value})
        }

        return (
        <Stack direction='row'>
            <Tooltip title="Extend hire time">
                <IconButton
                size={'small'}
                variant="contained"
                color="current"
                onClick={handleDialogOpen}
                >
                <MoreTimeIcon/>
                        <Dialog
                        open={this.state.dialogOpen}
                        onClose={handleDialogClose}
                      >
                        <form onSubmit={JobChange}>
                        <DialogTitle>Extend to</DialogTitle>
                        <DialogContent>
                            <Stack direction='row' mt={2} mb={2} spacing={1}>
                            <TextField label="Amount of weeks" id="extend_by" value={this.state.weeksAdded} onKeyDown={keyPress}/>
                            <TextField type="date" label="Amount of weeks" id="stop_job" defaultValue={this.props.row.stop_job} onKeyDown={keyPress} onChange={(event, key)=>{handleTextChange(event, 'stop_job')}}/>
                            </Stack>
                                <TextField
                                    id='notes_job'
                                mt={2}
                                multiline
                                maxRows={25}
                                fullWidth
                                value={this.state.note}
                                onChange={(event, key)=>{handleTextChange(event, 'note')}}
                                       />
                        </DialogContent>
                        <DialogActions>
                          <Button name='cancel' type="submit" >Cancel</Button>
                          <Button name='submit' type="submit">Confirm Changes</Button>
                        </DialogActions></form>
                      </Dialog>
                </IconButton>
            </Tooltip>
            {checkOutdated()}
        </Stack>
    )
    }
}
export default HireExtend;